export type CsSenderType = "CUSTOMER" | "STAFF";

export type CsImageSendStatus = "sending" | "failed";

export interface CsMessage {
  id: string;
  senderType: CsSenderType;
  senderName?: string;
  senderAvatarUrl?: string;
  content: string;
  messageType: "TEXT" | "IMAGE" | "BROADCAST" | "RENEWAL_CARD" | "SYSTEM_HINT";
  sentAt: string;
  /** 本地选图后的 blob 预览地址，发送成功后释放 */
  localPreviewUrl?: string;
  /** 仅本地发出的图片消息：上传/提交后端过程中的状态 */
  imageSendStatus?: CsImageSendStatus;
  recalled?: boolean;
}

export interface CsConversationBootstrap {
  conversationId: string;
}

export interface CsListMessagesResult {
  list: CsMessage[];
  hasOlder: boolean;
  historyRecycled?: boolean;
}

export interface CsPollNewMessagesResult {
  list: CsMessage[];
  recalledMessageIds?: string[];
  maxRecallEventId?: string;
}

export interface CsSyncReadedAndGetUnreadResult {
  conversationId: string;
  list: CsMessage[];
  unreadCount: number;
  hasOlder?: boolean;
  historyRecycled?: boolean;
  recalledMessageIds?: string[];
  maxRecallEventId?: string;
}

export const CS_WELCOME_MESSAGE_ID = "__cs_welcome__";
export const CS_WELCOME_TEXT = "您好，有什么可以帮助您？";
export const CS_ASSISTANT_AVATAR_URL = `${process.env.PUBLIC_URL || ""}/logo.png`;
export const CS_MAX_VISIBLE_MESSAGES = 200;
export const CS_HISTORY_RECYCLED_HINT = "历史消息已被回收，如有查询需要请联系客服";
